export const environment = {
  production: false,
  appConfig: {
    gatewayServiceBaseUrl: 'https://api-dev.talfinance.uk',
    notificationServiceBaseUrl: 'https://notification.Tal.dev',
  },
  landingPageUrl: 'https://www.talfinance.sa',
  appCDNConfig: {
    CDN: 'https://janafinancialqa.oss-me-central-1.aliyuncs.com/',
  },
  firebase: {},
  mapKey: 'AIzaSyDt-3iS_kTNAHFiFi32b2dSRU8NzlaWR8g',
  /** Decrypts the encrypted /api/Configuration/Moyasar response (EncryptionKeys:ClientConfigKey on the API). */
  clientConfigKey: '0MHexYh4hLpJ72mI1Z_-gMnC4OBrtbyY',
  moyassar: {
    publishableKey: 'pk_test_Uz5GW9oHGGPsQvxhboCVRANZMcpSZ3ZpG9QEDjFb',
  },
  ossBaseUrl: 'https://tal-oss-prod-01.oss-me-central-1.aliyuncs.com/DataFiles/',
  sentry: {
    dsn: 'https://3ba9832f93e57e336f74894926ec689d@o4510938287636480.ingest.de.sentry.io/4510949978931280',
    environment: 'development',
    tracesSampleRate: 0.5,
  },
};
